"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertNumber;
function assertNumber(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'number') {
    throw new TypeError("".concat(label, " needs to be a number"));
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertNumber.js
// module id = 1861
// module chunks = 0